import { z } from 'zod'

// Permissive validation: supported chains + relay networks (for cross-chain
// transfer destinations). Relay network validation happens at runtime when
// the data is available.
export const relayChainIdSchema = z.number().positive()
